/* eslint-disable array-callback-return */
/**
 * 消息盒子组件
 * @author sunzhiguang
 * @date 2020/6/10
 */
import React, { useCallback, useRef, useEffect, useState } from "react";
import { MessageDateFormType } from "@/types/chat/enum";
import "./index.less";
import { ChatMessage, Session } from "@/types/chat";
import ChatMessageItem from "@/components/chat/message/Item/ChatItem";
import { getMessageDateFormat } from "@/utils/date";
import { Checkbox } from "antd";
import { MessageEmitCategory } from "@jd/jdee.im.sdk/lib/es/enum/MessageEmitType";
import SysMessageItem from "@/components/chat/message/Item/SysItem";
import { ChatMessageType, MessageStatus } from "@jd/jdee.im.sdk/lib/es/protocol/message/Type";
import SysMessage from "@/components/chat/message/Sys";
import { useTranslation } from "react-i18next";
import Revoke from "@/components/chat/message/Revoke";
import Context from "@/components/chat/context";
import bus from "@/utils/bus";
import RefreshMessageBox from "../../handler/countDownHandler";
import ImService from "@/server/ImService";
import { connect } from "dva";
import ChatState from "@/types/chat/State";
interface MessageBoxProps {
  messages: ChatMessage[];
  session?: Session;
  sText?: string;
  sMid?: number;
  getLock: Function;
  unLock: Function;
  getCurrentMessageId: Function;
  setCurrentMessageId: Function;
  checkedVisible: Boolean;
  selectedRecordIds: string[];
  handleSelectChatRecord: Function;
  isInviteForward?: boolean;
  modalMessages?: ChatMessage[];
}
interface DvaDispatchProps {
  updateSessionMessageMid: Function;
  updateSessionMessagesTimestamp: Function;
  setVoiceMessageMap: Function;
}

let visbol: boolean;
type IProps = Readonly<MessageBoxProps & DvaDispatchProps & ChatState>;
function ChattingRecordsContainer(props: IProps) {
  // const { messages, session, sText = '', sMid = -1 } = props;
  const {
    messages,
    session,
    checkedVisible,
    selectedRecordIds = [],
    handleSelectChatRecord,
    selectedSession,
    isInviteForward,
    modalMessages
  } = props;
  // console.log('message box', messages, session);
  const { groupRosterIdentity } = React.useContext(Context);
  const { t } = useTranslation("chat");

  /**
   * strat 阅后即焚
   * 只有当前会话是单聊密聊会话，才去初始化倒计时实例和可见区域监听实例
   */
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const refreshMessageBox = session?.isSecret ? new RefreshMessageBox() : null;

  useEffect(() => {
    refreshMessageBox?.startTimer();
    return () => {
      refreshMessageBox?.clearTimer();
      refreshMessageBox?.destroy();
    };
  }, [refreshMessageBox]);

  const getSendTime = useCallback(
    (message) => {
      const sendTime = getMessageDateFormat(
        message.timestamp,
        MessageDateFormType.DATE_AGGREGATION
      );
      return <div className="time">{sendTime}</div>;
    },
    [t] // eslint-disable-line
  );

  if (messages.length > 0) {
    return (
      <div
        className={`message-node `}
        style={{ marginTop: messages[0].type === "unified_notice_message" ? "0px" : "8px" }}
      >
        {messages.map((message: any, index) => {
          if (message.category === MessageEmitCategory.SYSTEM) {
            if (
              message.type === ChatMessageType.SYS &&
              message.flag !== 100 &&
              !message.data?._sys_msg_type_
            ) {
              return (
                <div key={`s-2-${message.id}`} className={`${checkedVisible ? "readOnly" : ""}`}>
                  <SysMessage message={message} />
                </div>
              );
            } else {
              return (
                <div key={`s-${message.id}`} className={`${checkedVisible ? "readOnly" : ""}`}>
                  <SysMessageItem message={message} />
                </div>
              );
            }
          } else if (message.category === MessageEmitCategory.CHAT_MESSAGE) {
            if (message.revoke === 1 && !message.plusList) {
              return (
                <div key={`r-${message.id}`} className={`${checkedVisible ? "readOnly" : ""}`}>
                  <Revoke message={message} sessionType={selectedSession.sessionType} />
                </div>
              );
            } else if (message.type === ChatMessageType.PERMISSION_CHANGE) {
              return null;
            } else {
              return (
                <div
                  className={`chat-records-checkbox-section ${checkedVisible ? "readOnly" : ""}`}
                  onClick={() => handleSelectChatRecord(message)}
                  key={`c-${message.id}-${message.timestamp}`}
                >
                  {checkedVisible &&
                    !message.plusList &&
                    message.type !== ChatMessageType.SOLITAIRE &&
                    message.type !== ChatMessageType.GROUPNOTICE && (
                      <Checkbox
                        className="chat-records-checkbox"
                        checked={selectedRecordIds.includes(message.id)}
                        disabled={message.statusType === MessageStatus.EXPIRED}
                      />
                    )}
                  <div className="chat-message-item-container">
                    <ChatMessageItem
                      groupRosterIdentity={groupRosterIdentity}
                      sendTime={getSendTime(messages[0])}
                      prevMessage={null}
                      message={message}
                      getLock={() => {}}
                      unLock={() => {}}
                      setCurrentMessageId={() => {}}
                      shareRecords={true}
                      isInviteForward={isInviteForward}
                      modalMessages={modalMessages}
                    />
                  </div>
                </div>
              );
            }
          } else {
            return null;
          }
        })}
      </div>
    );
  }
  return null;
}

function mapStateToProps({ chat }: any) {
  const { selectedSession } = chat as ChatState;

  return { selectedSession };
}

function mapDispatchToProps(dispatch: any) {
  return {
    updateSessionMessageMid(data: { sendResult: any; sessionId: String }) {
      dispatch({ type: "chat/updateSessionMessageMid", payload: data });
    },
    updateSessionMessagesTimestamp(data: { timestamp: number }) {
      dispatch({ type: "chat/updateSessionMessagesTimestamp", payload: data });
    },
    setVoiceMessageMap(payload: boolean) {
      dispatch({ type: "chat/setVoiceMessageMap", payload });
    }
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(ChattingRecordsContainer);
